import { render, staticRenderFns } from "./itemDialogDeduct.vue?vue&type=template&id=8484af7e&scoped=true&"
import script from "./itemDialogDeduct.vue?vue&type=script&lang=js&"
export * from "./itemDialogDeduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8484af7e",
  null
  
)

export default component.exports